
export default {
  rab: {},
  tasks: [],
  pelaksanaan: {},
  biaya: [],
  events: [],
  taskTags: [],
  progressSearchQuery: '',
  progressFilter: null,
  ahsp: [],
  activities: null
}
